/** @type {string} */
const modalString = "modal";
export default modalString;
